import React, { Component } from 'react';
import PropTypes from 'prop-types';

class LeagueRosterSubnav extends Component {
  static propTypes = {
    division: PropTypes.object,
  };

  render() {
    return (
      <div id="subnav">
        <h2 className="title">
          Rostering
          <a
            className="helplink--ss-info"
            target="_blank"
            rel="noopener noreferrer"
            href="https://helpme-admin.teamsnap.com/article/2584-copy-or-transfer-members-to-a-division-or-team"
          />
        </h2>
      </div>
    );
  }
}

export default LeagueRosterSubnav;
